import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import Axios from "axios";

import "react-toastify/dist/ReactToastify.css";

import { MDBRow, MDBCol, MDBIcon, MDBCardHeader } from "mdbreact";
import { MDBCard, MDBCardUp, MDBAvatar, MDBCardBody } from "mdbreact";

import { Link } from "react-router-dom";

const Home = (props) => {
  const [cookies, setCookie] = useCookies(["authenticatedsession"]);

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const useMountEffect = (functionName) => useEffect(functionName, []);
  const [dtrProcessed, setDTRProcessing] = useState(false);

  const [showPreloader, setPreloader] = useState("none");

  const [frm, setValues] = useState({
    message: "",
    actualTime: "",
    actualDay: "",
    idnumber: "",
    accountname: "",
  });

  // const [rows, setRows] = useState([]);

  // function loadMyTimeLogs() {

  //   Axios.get(props.apiServer + "/mytimelogs?usertoken="  + sessionStorage.getItem("msal.uc"),bearer)
  //    .then(res => {

  //      setRows(res.data);
  //       setPreloader("none");

  //    })

  //    .catch(error => {

  //    });

  //  }

  const registerTimeRecord = () => {
    setPreloader("normal");
    Axios.post(
      props.apiServer +
        "/savetimeinout?token=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setDTRProcessing(false);
        if (res.data.status === "1") {
          setValues({
            ...frm,
            message: res.data.message,
            actualTime: res.data.actualTime,
            actualDay: res.data.actualDay,
            idnumber: res.data.idnumber,
            accountname: res.data.accountname,
          });

          setDTRProcessing(true);
          setPreloader("none");
          setTimeRecord(!setTimeRecord);
          console.log(res.data.message);
          //  loadMyTimeLogs();
        } else {
          console.log(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function loadData() {
    Axios.get(
      props.apiServer +
        "/getuserlogin?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setValues({
          ...frm,

          accountname: res.data[0].Name,
        });

        console.log(res.data[0].Name);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  //    const [profilephoto,setProfilePhoto]=useState('default.jpg');
  //  function getprofilepic() {

  //   Axios.get(props.apiServer + "/getprofilepic?token=" + sessionStorage.getItem("msal.uc"),bearer)
  //    .then(res => {

  //       setProfilePhoto(res.data[0].filename);
  //       setPreloader("none");
  //    })

  //    .catch(error => {

  //     console.log(error);
  //    });

  //  }

  //  useMountEffect(getprofilepic);

  //  useMountEffect(loadData);
  //  useMountEffect(loadMyTimeLogs);

  return (
    <section className="text-center my-5">
      <form className="needs-validation" noValidate>
        <section className="text-center my-5">
          <MDBRow className="pt-5 pb-5">
            <MDBCol md="6">
              <Link to={props.deployURL + "/receiving"}>
                <MDBIcon
                  icon="shopping-cart"
                  size="10x"
                  className="orange-text"
                />
                <h5 className="font-weight-bold my-4">Receiving</h5>
                <p className="grey-text mb-md-0 mb-5">
                  Encode and view all stocks you received.
                </p>
              </Link>
            </MDBCol>

            <MDBCol md="6">
              <Link to={props.deployURL + "/posmain"}>
                <MDBIcon
                  icon="cash-register"
                  size="10x"
                  className="blue-text"
                />
                <h5 className="font-weight-bold my-4">Transaction</h5>
                <p className="grey-text mb-md-0 mb-5">
                  Process sales,returns and deleted transactions here.
                </p>
              </Link>
            </MDBCol>
          </MDBRow>

          <h1>{cookies.authenticated}</h1>
        </section>
      </form>
    </section>
  );
};

export default Home;
